import { useState, useEffect } from 'react';
import Cookies from "universal-cookie";

// Custom hook to handle user authentication
const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState("");// State to hold the authentication status
  const cookies = new Cookies();

  useEffect(() => {
    // Function to check authentication by reading a token from cookies
    const checkAuth = () => {
      const token = cookies.get('c360_jwt_access');
      // Set authentication status based on the presence of the token
      setIsAuthenticated(!!token);
    };

    // Initial check when the component mounts
    checkAuth();
    // Handler to check authentication status when the window gains focus
    const cookieChangeHandler = () => {
      checkAuth();
    };

    window.addEventListener('focus', cookieChangeHandler);

    return () => {
      window.removeEventListener('focus', cookieChangeHandler);
    };
  }, []);

  // Return the authentication status
  return isAuthenticated;
};

export default useAuth;